import { Outlet } from 'react-router';

const Client = () => {
  return <Outlet />;
};

export default Client;
